import {
    CREATE_WEBHOOK,
    CREATE_WEBHOOK_FAILURE,
    CREATE_WEBHOOK_SUCCESS,
} from 'store/actions/types';

export const createWebhook = (payload) => {
    return {
        type: CREATE_WEBHOOK,
        payload: payload,
    };
};

export const createWebhookFailure = (error) => {
    return {
        type: CREATE_WEBHOOK_FAILURE,
        error: error,
    };
};

export const createWebhookSuccess = (response) => {
    return {
        type: CREATE_WEBHOOK_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/webhooks/createWebhooks.js